import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import {
  IOpenBulkDialogData,
  IOpenDialogData,
} from 'pages/dashboard/order-lists/type/open-dialog-state.interface';
import {
  bulkRetryUpdateInventoryAdjustment,
  retryUpdateFailedInventoryAdjustment,
} from 'redux-stores/actions';

export const OpenDialogConfig: Record<string, IOpenDialogData | null> = {
  retry: {
    title: 'Retry Update Inventory Adjustment',
    content: (documentNumber: string): string => {
      return `Are you sure to retry ${documentNumber}?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      documentNumber: string,
      location?: number,
    ): void => {
      dispatch(
        retryUpdateFailedInventoryAdjustment({
          documentNumber,
          location,
        }),
      );
    },
  },
};

export const OpenBulkDialogConfig: Record<string, IOpenBulkDialogData | null> =
  {
    Retry: {
      title: 'Retry Update Inventory Adjustments',

      content: (documentNumbers: string[]): string => {
        return `Are you sure to submit retry following inventory adjustments: \n\n ${documentNumbers.join(
          '\n',
        )}?`;
      },
      onConfirm: (
        dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
        documentNumbers: string[],
        location?: number,
      ): void => {
        dispatch(
          bulkRetryUpdateInventoryAdjustment({ documentNumbers, location }),
        );
      },
    },
  };
